module.exports = __webpack_public_path__ + "static/media/pencil-square.b6f4c684.svg";